import { v4 as uuidv4 } from 'uuid'
/** Functions in this file are used on server side also */

export const TRACE_ID_KEY = 'X-Amzn-Trace-Id'

export const createSessionTraceId = (userId: string) => {
  return `session_id=${uuidv4()}${
    userId ? `;user_id=${userId}` : ''
  };requested_by=web`
}

export const createTraceId = (sessionTraceId: string) => {
  return `request_id=${uuidv4()}${
    sessionTraceId ? `;${sessionTraceId}` : ''
  };t=${Date.now()}`
}
